<template>
  <div class="index-container">
    <div
      class="index-wrapper"
      :style="{ backgroundImage: 'url(' + themeData['homeBg'] + ')' }"
    >
      <swiper :options="swiperOption" class="swiper-wrapper">
        <swiper-slide
          v-for="(item, index) of levelData"
          :key="index"
          class="swiper-item-wrapper"
          :class="swiperItemBg(index)"
        >
          <div
            class="level-wrapper"
            v-for="(img, imgIndex) of item"
            :key="imgIndex"
            :class="levelImgWrapper(index, imgIndex)"
          >
            <img :src="levelImg(img)" alt="" @click="lessonDetail(img)" />
            <!-- <img :src="img.pic" alt="" @click="lessonDetail(img)"> -->
          </div>
        </swiper-slide>
        <div
          v-show="levelData.length > 1"
          class="swiper-button-prev"
          :style="{ backgroundImage: 'url(' + themeData['homePrevBg'] + ')' }"
          slot="button-prev"
        ></div>
        <div
          v-show="levelData.length > 1"
          class="swiper-button-next"
          :style="{ backgroundImage: 'url(' + themeData['homeNextBg'] + ')' }"
          slot="button-next"
        ></div>
      </swiper>
    </div>
    <div class="home-wrapper" v-if="themeData['userCenterImg']">
      <img :src="themeData['userCenterImg']" @click="goUserCenter" alt="" />
    </div>
    <div
      class="home-wrapper audio-wrapper"
      @click="changeVoice"
      v-if="themeData['voiceHomeImg']"
    >
      <img v-show="!voiceClose" :src="themeData['voiceHomeImg']" alt="" />
      <img v-show="voiceClose" :src="themeData['voiceCloseHomeImg']" alt="" />
    </div>
    <audio id="audio" autoplay="autoplay" controls hidden>
      <source :src="audioUrl" type="audio/mpeg" />
    </audio>
  </div>
</template>
<script>
// 首页
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { lessonList } from "api/lesson";
import themeData from "@/theme";
import lang from "../config/lang/index";
import introduction2 from "../common/media/introduction2.mp3";
import introduction1004 from "../common/media/introduction1004.mp3";
export default {
  name: "home",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      themeData: themeData["home"],
      page: "index",
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      levelData: [],
      voiceClose: false
    };
  },
  created() {
    // this.windowEventListener();
    // console.log('created window', window);
    // console.log('created window.prototype ', Window.prototype);
    // console.log('created window.prototype propertyIsEnumerable', window.propertyIsEnumerable('companyId'));
    // console.log('created window.prototype hasOwnProperty', window.hasOwnProperty('companyId'));
    // console.log('created window.companyId', window.companyId);
    setTimeout(() => {
      this.getLessonList();
    }, 0);
    console.log("enter");
  },
  computed: {
    audioUrl() {
      if (window.plateId === "1004") {
        return introduction1004;
      }
      return introduction2;
    }
  },
  mounted() {},
  methods: {
    // 获取课程
    getLessonList() {
      const params = { plate_id: window.plateId };
      lessonList(params).then(res => {
        var result = [];
        for (var i = 0; i < res.data.length; i += 4) {
          result.push(res.data.slice(i, i + 4));
        }
        this.levelData = result;
      });
    },
    // 去详情页
    lessonDetail(info) {
      if (info.need_pay) {
        this.$router.push({ path: "/pay", query: {} });
      } else if (info.lock_status) {
        this.$toast(lang("请完成上一关学习"));
      } else if (!info.lock_status) {
        this.$router.push({ path: "/explain", query: { id: info.id } });
      }
    },
    // 去个人中心
    goUserCenter() {
      this.$router.push({ path: "/user", query: {} });
    },
    // 改变语音开关
    changeVoice() {
      var audio = document.getElementById("audio");
      if (this.voiceClose) {
        audio.play();
      } else {
        audio.pause();
      }
      this.voiceClose = !this.voiceClose;
    },
    swiperItemBg(index) {
      return `swiper-item-bg-${index + 1}`;
    },
    levelImgWrapper(index, index2) {
      const imgIndex = index * 4 + index2 + 1;
      return `level${imgIndex}`;
    },
    levelImg(item) {
      const firstItem = this.levelData[0][0];
      if (item.need_pay) {
        if (item.rank === 2 && firstItem.pass) {
          return item.pic_active;
        }
        return item.pic_passive;
      } else {
        if (item.lock_status) {
          return item.pic_payed;
        }
        return item.pic_active;
      }
    },
    windowEventListener() {
      window.addEventListener(
        "onorientationchange" in window ? "orientationchange" : "resize",
        function() {
          if (window.orientation === 180 || window.orientation === 0) {
            console.log("竖屏状态！");
            // alert('竖屏状态！');
          }
          if (window.orientation === 90 || window.orientation === -90) {
            console.log("横屏状态！");
            // alert('横屏状态！');
          }
        },
        false
      );
    },
    kaishi() {
      var docElm = document.documentElement;
      // W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        // FireFox
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        // Chrome等
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        // IE11
        docElm.msRequestFullscreen();
      }
    }
  }
};
</script>
<style lang="scss">
@import "style/variable.scss";
@import "style/mixin.scss";
.index-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  // bottom: 0;
  width: 100%;
  @media screen and (orientation: landscape) {
    // background-color: red;
    /*横屏 css*/
  }
  .index-wrapper {
    width: 100%;
    height: 100%;
    // background-image: url("~img/map/bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    // background-size: 100% 100%;
    @media (max-width: 768px) {
      // position: absolute;
      // width: 100vh;
      // height: 100vw;
      // top: 0;
      // left: 100vw;
      // transform: rotate(90deg);
      // transform-origin: 0% 0%;
    }
    .swiper-wrapper {
      width: 100%;
      height: 100%;
      .swiper-item-wrapper {
        background-repeat: no-repeat;
        background-size: cover;
        &.swiper-item-bg-1 {
          background-image: url("~img/map/line1.png");
        }
        &.swiper-item-bg-2 {
          background-image: url("~img/map/line2.png");
        }
        &.swiper-item-bg-3 {
          background-image: url("~img/map/line3.png");
        }
      }
      .level-wrapper {
        float: left;
        cursor: pointer;
        img {
          width: rem(29.22);
        }
        &.level1 {
          margin-top: rem(10);
          margin-left: rem(2);
        }
        &.level2 {
          margin-top: rem(40);
          margin-left: rem(-3);
        }
        &.level3 {
          margin-top: rem(14);
          margin-left: rem(0);
        }
        &.level4 {
          margin-top: rem(28);
          margin-left: rem(5);
        }
        &.level5 {
          margin-top: rem(40);
          margin-left: rem(4);
        }
        &.level6 {
          margin-top: rem(8);
          margin-left: rem(-5);
        }
        &.level7 {
          margin-top: rem(37);
          margin-left: rem(4);
        }
        &.level8 {
          margin-top: rem(12.5);
          margin-left: rem(3.5);
        }
        &.level9 {
          margin-top: rem(20);
          margin-left: rem(9);
        }
        &.level10 {
          margin-top: rem(38);
          margin-left: rem(5);
        }
        &.level11 {
          margin-top: rem(7);
          margin-left: rem(-5);
        }
        &.level12 {
          margin-top: rem(30);
          margin-left: rem(0);
        }
      }
    }
  }
  .swiper-button-prev {
    width: rem(5.4);
    height: rem(8.81);
    // background-image: url("~img/map/prev.png");
    background-size: rem(5.4) rem(8.81);
    z-index: 10;
  }
  .swiper-button-next {
    width: rem(5.4);
    height: rem(8.81);
    // background-image: url("~img/map/next.png");
    background-size: rem(5.4) rem(8.81);
    z-index: 10;
  }
  .home-wrapper {
    position: absolute;
    top: rem(2.2);
    right: rem(2.2);
    width: rem(4);
    cursor: pointer;
    z-index: 10;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
    &.audio-wrapper {
      width: rem(5);
      right: rem(7);
    }
  }
}
</style>
